import React, { FC, useEffect, useRef } from 'react'
import { StyledCTAContainer } from '../search-filters-cta/search-filter-cta.styles'
import useScrollPosition from '../../hooks/use-scroll-position-hook'
import { FilterButton } from '../filter-button/filter-button'
import { FilterPills } from '../filter-pills/filter-pills'

export const SearchFilterRelevanceCTAs: FC = () => {
    const { isUserScrolled } = useScrollPosition(60)
    const selectedFiltersWrapperRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        // when user starts to scroll down, scroll pills to left so filter and sort is visible
        if (isUserScrolled && selectedFiltersWrapperRef.current) {
            selectedFiltersWrapperRef.current.scrollTo({ left: 0, behavior: 'smooth' })
        }
    }, [isUserScrolled])

    return (
        <StyledCTAContainer id="pills-action-area" data-testid="pills-action-area">
            <FilterPills />
            <FilterButton />
        </StyledCTAContainer>
    )
}
